import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import type { AccountDTO } from "../../../../common/types/AccountDTO";
import { baseQuery } from "../../client/DefaultClient";

export const accountService = createApi({
  reducerPath: "accountService",
  baseQuery: fetchBaseQuery(baseQuery),
  tagTypes: ["Account"],
  endpoints: (builder) => ({
    getAccount: builder.query<AccountDTO, { id: string }>({
      query: ({ id }) => `api/identity/accounts/${id}`,
      providesTags: (account) => [{ type: "Account", id: account?.id }],
    }),
  }),
});

export const { useGetAccountQuery } = accountService;
